import AbsSection from '../common/AbsSection';
import MoviePlayer from '../common/MoviePlayer';
import { TweenMax } from 'gsap/all';

import { getReencodedUriParams, getUriCombinedParams } from '../common/util';

class SecGate extends AbsSection {

    constructor(_store = {}, _el = '') {
        super('gate', _store, _el);
    }

    setting() {
        this.videoList = {
            mobile: {
                loop: {
                    url: this.moviepath + '/new/1_castlerooping_MO_low.mp4',
                    width: 1920 * 0.7, height: 1080 * 0.7
                },
                out: {
                    url: this.moviepath + '/castle/2_enter_MO_low.mp4',
                    width: 1920 * 0.7, height: 1080 * 0.7
                }
            },
            tablet: {
                loop: {
                    url: this.moviepath + 'new/1_castlerooping_MO_low.mp4',
                    width: 1920, height: 1080
                },
                out: {
                    url: this.moviepath + '/castle/2_enter_MO_low.mp4',
                    width: 1920, height: 1080
                }
            },
            pc: {
                loop: {
                    url: this.moviepath + '/new/1_castlerooping_PC_low.mp4',
                    width: 2276, height: 1280
                },
                out: {
                    url: this.moviepath + '/castle/2_enter_PC_low.mp4',
                    width: 2276, height: 1280
                }
            }
        }[this.store.getState().config.device];

        this.vidLoop = new MoviePlayer({
            url: this.videoList.loop.url,
            parentNode: $(this.el + ' .vid .draggable'),
            movieW: this.videoList.loop.width, movieH: this.videoList.loop.height,
            selector: 'secGateloop', videoControl: 'preload="auto" playsinline muted="muted" loop',
            isBgType: false,
            stateCallback: (state) => { }
        });

        this.vidOut = new MoviePlayer({
            url: this.videoList.out.url,
            parentNode: $(this.el + ' .vid .draggable'),
            movieW: this.videoList.out.width, movieH: this.videoList.out.height,
            selector: 'secGateOut', videoControl: 'preload="auto" playsinline muted="muted"',
            isBgType: false,
            stateCallback: (state) => {
                if (state === 'ended') {
                    this.transitionEnd();
                }
            }
        });

        let cssobj = { width: this.videoList.loop.width, height: this.videoList.loop.height };
        if (this.$win.width() > this.videoList.loop.width) {
            cssobj['margin-left'] = -this.videoList.loop.width / 2;
            cssobj['left'] = '50%';
        }
        this.vidLoop.node.css(cssobj);
        this.vidOut.node.css(cssobj);

        this.drag = Draggable.create(this.el + " .drag-wrap", { type: "scroll", edgeResistance: 1, throwProps: true })[0];

        this.moreLink = $('.more-link');

        this.title = $(this.el + ' .title');
        this.infoList = $(this.el + ' .info-list ');
        this.enterBtn = $(this.el + ' .section-contents button.btn-general');
        this.vipBox = $(this.el + ' .box-wrap');
        this.floatingBtn = $(this.el + ' .section-contents .floating-wrap');

        this.reset();
    }

    addEvents() {
        $('.btn-floating-record').on('click', e => {
            const params = getReencodedUriParams(location.href) || {};
            const url = getUriCombinedParams($('.btn-floating-record').attr('href') || '', params);
            $('.btn-floating-record').attr('href', url);
        });

        this.enterBtn.on('click', e => {
            this.store.dispatch(this.actions.setNowpage($(e.currentTarget).data('name')));
        });

        $('#layer-floating-update .btn-living').on('click', e => {
            $('#layer-floating-update .layer-btn-close').trigger('click');
            this.store.dispatch(this.actions.setNowpage('livingroom'));
        });

        $(this.el + ' .box-wrap .btn-certify').on('click', e => {
            $.ajax({
                url: `/event/200624_thirdupdate/invitation`,
                data: { invitationCode: $('#vipCheckCode').val() },
                type: 'GET', dataType: 'json', contentType: 'application/json',
            })
                .fail(() => console.log('error..'))
                .done((data) => {
                    if (data) {
                        location.href = location.href + '?i9Code=' + $('#vipCheckCode').val();
                    } else {
                        alert('인증 코드를 다시 확인해주세요.');
                        $('#vipCheckCode').val('').focus();
                    }
                })
                .always(() => { });
        });


    }

    setAniObj() {
        super.setAniObj();
        TweenMax.set(this.title, { autoAlpha: 0, scale: 1.3 });
        TweenMax.set(this.infoList, { autoAlpha: 0, y: 50, scale: 1.3 });
        TweenMax.set(this.floatingBtn, { autoAlpha: 0, scale: 1, y: 50 });
        TweenMax.set(this.enterBtn, { autoAlpha: 0, scale: 1, y: 50 });
        TweenMax.set(this.vipBox, { autoAlpha: 0, scale: 1, y: 50 });
        TweenMax.set(this.vidLoop.node, { autoAlpha: 0, scale: 1.3 });

        TweenMax.set(this.moreLink, { y: -70 });
    }

    titleAni() {
        this.title.show();
        TweenMax.to(this.title, 1.5, { autoAlpha: 1, scale: 1, delay: 0.5 });
        TweenMax.to(this.infoList, 1.5, { autoAlpha: 1, y: 0, scale: 1, delay: 0.5 });
        TweenMax.to(this.floatingBtn, 1, { autoAlpha: 1, y: 0, ease: Quint.easeOut, delay: 1.1 });
        TweenMax.to(this.enterBtn, 1, { autoAlpha: 1, y: 0, ease: Quint.easeOut, delay: 1.3 });
        TweenMax.to(this.vipBox, 1, { autoAlpha: 1, y: 0, ease: Quint.easeOut, delay: 1.3 });
        TweenMax.to(this.vidLoop.node, 1.7, { autoAlpha: 1, scale: 1, ease: Quint.easeOut });
        TweenMax.to(this.moreLink, 0.4, { y: 0, delay: 0.8, ease: Quint.easeOut });
    }

    start() {
        super.start();
        this.store.dispatch(this.actions.addSecCookies(this.name));
        this.vidioReset(this.vidLoop, 2, true).play(0);
    }

    end() {
        super.end();
        this.vidioReset(this.vidLoop, 1, true).pause();
        setTimeout(() => this.vidioReset(this.vidLoop, 1, false), 1000);
        this.vidioReset(this.vidOut, 2, true).play(0);

        TweenMax.to(this.title, 1.2, { autoAlpha: 0, scale: 1.3, ease: Quint.easeIn });
        TweenMax.to(this.infoList, 1.2, { autoAlpha: 0, y: 50, scale: 1.3, ease: Quint.easeIn });
        TweenMax.to(this.floatingBtn, 1.2, { autoAlpha: 0, scale: 1.3, y: 50, ease: Quint.easeIn });
        TweenMax.to(this.enterBtn, 1.2, { autoAlpha: 0, scale: 1.3, y: 50, ease: Quint.easeIn });
        TweenMax.to(this.vipBox, 1.2, { autoAlpha: 0, scale: 1.3, y: 50, ease: Quint.easeIn });
        TweenMax.to(this.moreLink, 1.2, { y: -70, ease: Quint.easeIn });
    }

    reset() {
        super.reset();
        this.vidioReset(this.vidOut).pause();
        this.vidioReset(this.vidLoop).pause();
    }


} // end of class
export default SecGate;